export const promotionInfo = {
	title: "Datos de la promoción",
	description:
		"Defina todos los parámetros necesarios para crear una promoción especializada para sus clientes.",
	channelAndAudience: {
		title: "Canal y público objetivo de la promoción",
		description: "Elija el canal de distribución y quién podrá recibir la promoción.",
		channelTitle: "Elija el tipo de canal",
		channels: {
			cashlessMesas: {
				title: "Cashless/Mesas",
				description: "Promoción aplicada en la venta cashless o mesas",
			},
			ficha: {
				title: "Ficha",
				description: "Promoción aplicada en la venta ficha",
			},
			totemFicha: {
				title: "Tótem Ficha",
				description: "Promoción aplicada en el tótem ficha",
			},
		},
		audienceTitle: "¿Quién podrá recibir esta promoción?",
		audience: {
			everybody: "Todos los clientes",
			identifiedCpf: "Cliente identificado con CPF",
		},
		identifiedCpfWarning:
			"Es necesario que los tótems tengan conexión a internet para promociones con identificación de cliente.",
	},
	generalData: {
		title: "Datos generales de la promoción",
	},
	promotionName: {
		label: "Nombre de la promoción",
		placeholder: "Ingrese el nombre de la promoción",
	},
	promotionDescription: {
		label: "Descripción de la promoción",
		placeholder: "Ingrese la descripción de la promoción",
	},
	expiration: {
		label: "Expiración",
		info:
			"La promoción será válida hasta la fecha seleccionada. Cuando llegue la fecha de expiración, la promoción quedará inactiva y usted podrá cambiar la fecha de expiración.",
		notExpire: "No expira",
	},
	automaticMessage: {
		label: "Mensajes automáticos para clientes",
		info:
			"Todos los clientes que ganen la promoción reciben mensajes automáticos a través del canal seleccionado. Estos envíos tienen costo",
		sendMessage: "Enviar mensajes automáticos",
	},
	whatsUp: {
		label: "Mostrar promociones en '¿Qué hay de bueno?'",
		info: "Todas las promociones habilitadas serán mostradas en '¿Qué hay de bueno?'.",
		showPromotions: "Mostrar promociones en '¿Qué hay de bueno?'",
	},
	places: "Locales de la promoción",
	errors: {
		requiredField: "Este campo es obligatorio",
		dateFormat: "Formato de fecha inválido",
		dayDiff: "Necesario al menos un día de diferencia",
		selectPlace: "Seleccione al menos un local",
		maxUses:
			"Valor no puede ser superior a la cantidad de productos definida en el paso anterior",
	},
};
